import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import {
  IconButton,
  Tooltip,
} from '@mui/material';
import { useState } from 'react';

interface RefreshButtonProps {
  onRefresh: () => void;
}
export const RefreshButton = ({ onRefresh }: RefreshButtonProps) => {
  const [rotateIcon, setRotateIcon] = useState(0);

  const handleRefreshClick = () => {
    setRotateIcon(rotateIcon + 1);
    onRefresh();
  };

  return (
    <Tooltip arrow title="Refresh" placement="top">
      <IconButton size="large" color="primary" onClick={handleRefreshClick}>
        <CachedOutlinedIcon
          sx={{
            fontSize: '2rem',
            transition: 'transform 1s ease',
            transform: `rotate(${rotateIcon * 360}deg)`,
          }}
        />
      </IconButton>
    </Tooltip>
  );
};
